export default class ShoppingCart {
  constructor(options) {
    this.cartForm = document.querySelector("#cart")
    this.itemQuantityInputs = this.cartForm.getElementsByClassName("item-quantity")

    for (let itemQuantity of this.itemQuantityInputs) {
      itemQuantity.addEventListener("change", this.update.bind(this))
    }

    if (options.requiredAgreement) {
      this.cartForm.addEventListener("submit", this.submit.bind(this))

      this.shoppingAgreementElement = this.cartForm.querySelector("#shopping-agreement")
    }
  }

  update() {
    this.cartForm.submit()
  }

  submit(event) {
    if (!this.shoppingAgreementElement.checked) {
      event.preventDefault()

      window.alert("You must agree with the terms and conditions to checkout.")

      this.shoppingAgreementElement.focus()
    }
  }
}
